import * as React from 'react';
import {
	buildWorkOrderCheckComparisonRows,
	getWorkOrderCheckOutcome,
} from '../../utils/InvoiceUtils';
import { WorkOrderCheckAlert } from './WorkOrderCheckAlert';
import { WorkOrderCheckComparisonTable } from './WorkOrderCheckComparisonTable';
import { getWorkOrderCheckSeverity } from './workOrderCheckSeverity';
import { withUserType } from '../withUserType';

interface WorkOrderCheckWarningProps {
	workOrderCheck: any;
	parsedData: any;
	workOrder: any;
	userType?: string;
}

/**
 * The same evidence kept on the invoice form after the uploader chose to continue anyway, so the
 * reason stays in front of whoever reviews the invoice rather than living only in a modal that has
 * already been dismissed. Same alert and table as the modal, without the card or the buttons.
 */
const WorkOrderCheckWarningComponent: React.FC<WorkOrderCheckWarningProps> = ({
	workOrderCheck,
	parsedData,
	workOrder,
	userType,
}) => {
	const rows = buildWorkOrderCheckComparisonRows(workOrderCheck, parsedData, workOrder, userType);
	const severity = getWorkOrderCheckSeverity(getWorkOrderCheckOutcome(workOrderCheck));

	return (
		<div className="flex w-full flex-col gap-y-m">
			<WorkOrderCheckAlert
				title={severity.title}
				subtitle={severity.subtitle}
				iconClassName={severity.iconClassName}
			/>
			<WorkOrderCheckComparisonTable
				rows={rows}
				invoiceCellClassName={severity.invoiceCellClassName}
			/>
		</div>
	);
};

export const WorkOrderCheckWarning = withUserType(WorkOrderCheckWarningComponent as any) as any;

export default WorkOrderCheckWarning;
